import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiFetch } from '../api.js';
import { useAuth } from '../context/AuthContext.jsx';
import { useEmbeddedNavigation } from '../hooks/useEmbeddedMode.js';
import Button from '../ui/Button.jsx';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/Card.jsx';

export default function VerifyRecoveryEmailPage() {
  const [searchParams] = useSearchParams();
  const { navigateEmbedded } = useEmbeddedNavigation();
  const { setSession } = useAuth();
  const [state, setState] = useState('loading');
  const [message, setMessage] = useState('');
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (hasStartedRef.current) {
      return undefined;
    }

    hasStartedRef.current = true;
    let cancelled = false;
    const token = searchParams.get('token');

    const run = async () => {
      if (!token) {
        setState('error');
        setMessage('Lien de verification manquant.');
        return;
      }

      try {
        const payload = await apiFetch(`/api/family/recovery-email/verify?token=${encodeURIComponent(token)}`);
        if (cancelled) return;

        if (payload?.token) {
          setSession({ token: payload.token, member: payload.member });
        }

        setState('success');
        setMessage('Votre email est verifie. Redirection...');
        window.setTimeout(() => {
          navigateEmbedded('/', { replace: true });
        }, 600);
      } catch (error) {
        if (cancelled) return;
        setState('error');
        setMessage(error?.message || 'Impossible de verifier votre email.');
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [navigateEmbedded, searchParams, setSession]);

  return (
    <div className="min-h-full flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <Card className="overflow-hidden">
          <CardHeader>
            <div className="ptcm-section-pill w-fit">Verification</div>
            <CardTitle className="mt-4 text-2xl">Confirmer mon email</CardTitle>
            <CardDescription>
              {state === 'loading' ? 'Verification du lien en cours.' : 'Etat de votre adresse email.'}
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {state === 'loading' ? (
              <div className="rounded-[24px] border border-ptcm-border bg-ptcm-panel/60 px-4 py-5 text-sm text-ptcm-ink dark:border-gray-800 dark:bg-gray-900/60 dark:text-gray-100">
                Verification en cours...
              </div>
            ) : null}

            {state !== 'loading' ? (
              <div className={`rounded-[24px] px-4 py-4 text-sm ${
                state === 'success'
                  ? 'border border-green-200/80 bg-green-50/90 text-green-800 dark:border-green-900/40 dark:bg-green-900/20 dark:text-green-200'
                  : 'border border-red-200/80 bg-red-50/90 text-red-700 dark:border-red-900/40 dark:bg-red-900/20 dark:text-red-300'
              }`}>
                {message}
              </div>
            ) : null}

            {state === 'error' ? (
              <Button className="w-full" onClick={() => navigateEmbedded('/', { replace: true })}>
                Retour a l'accueil
              </Button>
            ) : null}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
